import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { QuestionPanel } from './questionPanel/QuestionPanel';
import { QuestionTab } from './questionTab/QuestionTab';
import { selectProfile } from 'redux/reducers/session';

const SelfAssessment = () => {
  const [activeTab, setActiveTab] = useState();
  const currentProfile = useSelector(selectProfile);
  return (
    <div data-testid="self-assessment-page">
      <QuestionTab tab={activeTab} language={currentProfile?.language} />
      <QuestionPanel setActiveTab={setActiveTab} />
    </div>
  );
};
export default SelfAssessment;
